import { render, staticRenderFns } from "./CargarResultadoExamen.vue?vue&type=template&id=5bba21f5&"
import script from "./CargarResultadoExamen.vue?vue&type=script&lang=js&"
export * from "./CargarResultadoExamen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports